import { render, staticRenderFns } from "./idCardVerifyConfig.vue?vue&type=template&id=01acf848&scoped=true&"
import script from "./idCardVerifyConfig.vue?vue&type=script&lang=js&"
export * from "./idCardVerifyConfig.vue?vue&type=script&lang=js&"
import style0 from "./idCardVerifyConfig.vue?vue&type=style&index=0&id=01acf848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01acf848",
  null
  
)

export default component.exports